export default "__VITE_ASSET__B2G7lpop__"